import React from "react";
import { i18n } from "../../../../../configuration/i18n";
import { TextInput } from "../../../../../common/adapters/primaries/form/inputs/text.input";
import { ThemeConfigurationBlockType } from "../types";

interface Props {
    data: ThemeConfigurationBlockType;
    isSubmitted: boolean
    onChange: (key: keyof ThemeConfigurationBlockType, value: string) => void;
}

export const AboutConfiguration = (props: Props): JSX.Element => {
    return (
        <div>
            <TextInput type={'color'}
                       error={props.isSubmitted && (!props.data.textColor || props.data.textColor.length === 0)}
                       label={i18n.company.text_color}
                       value={props.data.textColor ?? ''}
                       raiseUpdates={(value: string) => props.onChange('textColor', value)}/>

            <TextInput type={'color'}
                       error={props.isSubmitted && (!props.data.titleColor || props.data.titleColor.length === 0)}
                       label={i18n.company.title_color}
                       value={props.data.titleColor ?? ''}
                       raiseUpdates={(value: string) => props.onChange('titleColor', value)}/>

            <TextInput type={'color'}
                       error={props.isSubmitted && (!props.data.backgroundColor || props.data.backgroundColor.length === 0)}
                       label={i18n.company.background_color}
                       value={props.data.backgroundColor ?? ''}
                       raiseUpdates={(value: string) => props.onChange('backgroundColor', value)}/>
        </div>
    )
}
